import './App.css';
import ReactDOM from "react-dom/client";
import { HashRouter, Routes, Route } from "react-router-dom";

import OneDayToDoPrivacyPolicy from './pages/OneDayToDoPrivacyPolicy';
import DefaultPage from './pages/DefaultPage';
import PomodoroPrivacyPolicy from './pages/PomodoroPrivacyPolicy';
import ShieldVpnPrivacyPolicy from './pages/ShieldVpnPrivacyPolicy';
import AlphaPlayerPrivacyPolicy from './pages/AlphaPlayerPrivacyPolicy';
import HabbitRootTermAndConditions from './pages/habbitRoot/HabbitRootTermAndConditions';
import HabbitRootPrivacyPolicy from './pages/habbitRoot/HabbitRootPrivacyPolicy';
import PrivacyPolicy from './pages/admobDashboardPrcyPolicy';
import Privacytermsarrowtapaway from './pages/privacytermsarrowtapaway';
import RetroBricsPrivacyPolicy from './pages/retrobricsprivacypolicy';
import AnimalEscapePrivacyPolicy from './pages/animalEscapePrivacyPolicy';
import PdfStudioPrivacyPolicy from './pages/pdfStudioPrivacyPolicy';
import FocusOSPrivacyPolicy from './pages/Focusosprivacypolicy';
import WaterWisePrivacyPolicy from './pages/waterWisePrivacyPolicy';
import BladeRushPrivacyPolicy from './pages/Bladerushprivacypolicy';
import DBLearnPrivacyPolicy from './pages/dbLearnPrivacyPolicy';
import ChargeSparkPrivacyPolicy from './pages/ChargeSparkPrivacyPolicy';
import ScreenSparkPrivacyPolicy from './pages/ScreenSparkPrivacyPolicy';

function App() {
  return (
    <HashRouter>
      <Routes>
        <Route exact path="/" element={<DefaultPage />} />
        <Route exact path="/oneDayToDoPrivacyPolicy" element={<OneDayToDoPrivacyPolicy />} />
        <Route exact path="/pomodoroPrivacyPolicy" element={<PomodoroPrivacyPolicy />} />
        <Route exact path="/alphaPlayerPrivacyPolicy" element={<AlphaPlayerPrivacyPolicy />} />
        <Route exact path="shieldVpnPrivacyPolicy" element={<ShieldVpnPrivacyPolicy />} />
        <Route exact path="/AlphaLauncherPrivacyPolicy" element={<AlphaPlayerPrivacyPolicy />} />
        <Route exact path="/HabbitRootTermAndConditions" element={<HabbitRootTermAndConditions />} />
        <Route exact path="/HabbitRootPrivacyPolicy" element={<HabbitRootPrivacyPolicy />} />
        <Route exact path="/AdmobDashboardPrivacyPolicy" element={<PrivacyPolicy />} />
        <Route exact path="/Privacytermsarrowtapaway" element={<Privacytermsarrowtapaway />} />
        <Route exact path="/RetroBricsPrivacyPolicy" element={<RetroBricsPrivacyPolicy />} />
        <Route exact path="/AnimalEscapePrivacyPolicy" element={<AnimalEscapePrivacyPolicy />} />
        <Route exact path="/PdfStudioPrivacyPolicy" element={<PdfStudioPrivacyPolicy />} />
        <Route exact path="/FocusOSPrivacyPolicy" element={<FocusOSPrivacyPolicy />} />
        <Route exact path="/WaterWisePrivacyPolicy" element={<WaterWisePrivacyPolicy />} />
        <Route exact path="/Bladerushprivacypolicy" element={<BladeRushPrivacyPolicy />} />
        <Route exact path="/dbLearnPrivacyPolicy" element={<DBLearnPrivacyPolicy />} />
        <Route exact path="/chargeSparkPrivacyPolicy" element={<ChargeSparkPrivacyPolicy />} />
        <Route exact path="/screenSparkPrivacyPolicy" element={<ScreenSparkPrivacyPolicy />} />
      </Routes>
    </HashRouter>


  );
}

export default App;
